<template>
  <section class="content">
    <div class="row">
      <div class="col-md-8 col-xs-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <i class="fa fa-credit-card mr-5"></i>{{'marketplace_fees' | translate}}
          </div>
          <div class="box-body">
            <div class="row pt-10">
              <div class="col-xs-12">
                <div v-if="feesLoading">
                  <img class="loading-gif" src="/static/img/blabla.svg"/>
                </div>
                <div class="nav-tabs-custom" v-else>
                  <ul class="nav nav-tabs">
                    <template v-for="(value, key, index) in fees">
                      <li :class="[index + 1 === selectedMpFee ? 'active' : '']">
                        <a href="#tab_1-1" data-toggle="tab" aria-expanded="true" @click="() => {selectedMpFee = key}">
                          <img class="img-responsive img-channel" :src="`/static/img/${$store.getters.salesChannelById(key).img}`"/>
                        </a>
                      </li>
                    </template>
                  </ul>
                  <div class="tab-content">
                    <div id="tab_1-1" class="tab-pane active">
                      <table class="table table-responsive mt-10">
                        <thead>
                        <tr>
                          <th>{{'percentage' | translate($store.getters.language)}}</th>
                          <th>{{'return_percentage' | translate($store.getters.language)}}</th>
                          <th>{{'valid_from' | translate($store.getters.language)}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="fee in fees[selectedMpFee]">
                          <!--<template v-if="isEditable(fee)">
                            <td>
                              <div class="input-group">
                                <div class="input-group-addon">
                                  %
                                </div>
                                <input class="form-control normal" v-model="fee.percent">
                                <div class="input-group-btn">
                                  <button class="btn btn-info btn-flat" @click="updateSelectedFee(fee)"><i class="fa fa-save"></i></button>
                                </div>
                              </div>
                            </td>
                            <td><datepicker placeholder="Select Date" v-model="fee.valid_from"></datepicker></td>
                          </template>-->
                          <!--<template v-else>-->
                            <td>{{fee.percent | percentage}}</td>
                            <td>{{fee.return_fee | currency}}</td>
                            <td>{{moment(fee.valid_from).format('DD.MM.YYYY HH:mm:ss')}}</td>
                          <!--</template>-->
                        </tr>
                        <tr>
                          <td :colspan="3">
                            <div class="input-group" style="width: 100%;">
                              <div class="input-group-addon">
                                %
                              </div>
                              <input type="text" class="form-control" v-model="newFee.percent">
                              <div class="input-group-addon">
                                €
                              </div>
                              <input type="text" class="form-control" v-model="newFee.return_fee">
                              <div class="input-group-addon italic" disabled>
                                {{'valid_from' | translate}}: {{liveTime}}
                              </div>
                              <div class="input-group-btn">
                                <button class="btn btn-success btn-flat" @click="updateFees(selectedMpFee)"><i class="fa fa-plus"></i></button>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-xs-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <i class="fa fa-truck mr-5"></i>Zusätzliche schuhe.de Gebühren
          </div>
          <div class="box-body">
            <template v-if="ccFeesLoading">
              <img class="wt-loading-gif" src="/static/img/blabla.svg"/>
            </template>
            <template v-else>
              <div class="row mb-10">
                <div class="col-xs-12">
                  <div class="input-group" style="width: 100%;">
                    <div class="input-group-addon">
                      <span>Click&Collect Disagio %</span>
                    </div>
                    <input type="text" class="form-control" :disabled="ccFeesLoading" v-validate="{required: true, regex: /^\d+([\,]\d+)*([\.]\d+)?$/}" data-vv-as="Disagio" data-vv-scope="ccFees" name="cc_disagio" v-model="ccFees.cc_disagio">
                  </div>
                  <span v-show="errors.has('ccFees.cc_disagio')" class="small text-danger">{{ errors.first('ccFees.cc_disagio') }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <div class="input-group" style="width: 100%;">
                    <div class="input-group-addon">
                      <span>{{'cost_per_month' | translate}} €</span>
                    </div>
                    <input type="text" class="form-control" v-validate="{required: true, regex: /^\d+([\,]\d+)*([\.]\d+)?$/}" :disabled="ccFeesLoading" v-model="ccFees.cost_per_month" name="cost_per_month" :data-vv-as="'cost_per_month' | translate" data-vv-scope="ccFees">
                  </div>
                  <span v-show="errors.has('ccFees.cost_per_month')" class="small text-danger">{{ errors.first('ccFees.cost_per_month') }}</span>
                </div>
              </div>
            </template>
          </div>
          <div class="box-footer" v-if="!ccFeesLoading">
            <div class="col-xs-12 text-right pull-right">
              <button @click="postCCFees" class="btn btn-flat btn-success">
                <i :class="['fa mr-5', ccFeesLoading ? 'fa-spinner fa-spin' : 'fa-save']"></i>{{'save' | translate | capitalize}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import moment from 'moment'
  export default {
    data () {
      return {
        twoHoursFuture: moment().add(3, 'hours').format('DD.MM.YYYY, HH:mm:ss a'),
        feesLoading: true,
        ccFeesLoading: true,
        selectedMpFee: 0,
        moment: moment,
        liveTime: moment().add(3, 'hours').format('DD.MM.YYYY HH:mm:ss'),
        fees: [],
        ccFees: {}
      }
    },
    computed : {
      newFee () {
        return  {
          percent: 0,
          valid_from: moment(),
          return_fee: this.selectedMpFee === '4' ? 2.10 : 0
        }
      }
    },
    methods: {
      postCCFees () {
        this.ccFeesLoading = true
        if (this.$validator.validateAll()) {
          this.ccFees.cc_disagio = this.ccFees.cc_disagio.toString().replace(',', '.')
          this.ccFees.cost_per_month = this.ccFees.cost_per_month.toString().replace(',', '.')
          API.put(`accounting/companies/${this.$route.params.id}/clickAndCollect/fees`, this.ccFees)
            .then(res => {
              this.ccFeesLoading = false
            })
        }
      },
      calcLiveTime () {
        this.liveTime = moment().add(2, 'hours').format('DD.MM.YYYY HH:mm:ss')
      },
      updateFees (id) {
        this.feesLoading = true
        this.newFee.valid_from = moment().add(3, 'hours').format('YYYY-MM-DD HH:mm:ss')
        this.newFee.sales_channel_id = id
        this.newFee.percent = this.newFee.percent.toString().replace(',', '.')
        this.newFee.return_fee = this.newFee.return_fee.toString().replace(',', '.')
        API.post(`accounting/companies/${this.$route.params.id}/fees`, this.newFee)
          .then(res => {
            API.get(`accounting/companies/${this.$route.params.id}/fees`)
              .then(res => {
                this.fees = res.data
                this.feesLoading = false
              })
          })
          .catch(error => {
            console.log(error)
          })
      },
      updateSelectedFee (fee, index) {
        this.feesLoading = true
        fee.percent = fee.percent.toString().replace(',', '.')
        API.post(`accounting/companies/${this.$route.params.id}/fees`, fee)
          .then(res => {
            fee.percent = fee.percent.toFixed(2).toString().replace('.', ',')
            this.selectedMpFee = Object.keys(res.data)[0]
            this.feesLoading = false
          })
          .catch(error => {
            console.log(error)
          })
      },
      isEditable (fee) {
        let twoHs = moment().add(2, 'hours')
        let date = moment(fee.valid_from)
        return date.isAfter(twoHs)
      }
    },
    mounted () {
      setInterval(this.calcLiveTime, 1000)
      this.config = false
      this.type = 'barcode'
      API.all([API.get(`accounting/companies/${this.$route.params.id}/fees`), API.get(`accounting/companies/${this.$route.params.id}/clickAndCollect/fees`)])
        .then(API.spread((res, ccRes) => {
          this.fees = res.data
          this.ccFees = ccRes.data
          this.selectedMpFee = Object.keys(this.fees)[0]
          this.feesLoading = false
          this.ccFeesLoading = false
        }))
    }
  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .loading-gif {
    max-width: 345px;
    margin-left: 42%;
  }
  .italic {
    font-style: italic;
  }
</style>
<style>
  .multiselect, .multiselect__input, .multiselect__single, .multiselect--active {
    font-size: 14px !important;
    background: transparent !important;
    color: #ffffff !important;
    z-index: 3 !important;
  }
  .multiselect__tags {
    min-height: 40px;
    display: block;
    padding: 8px 40px 0 8px;
    border-radius: 0px !important;
    border: 1px solid rgba(255,255,255,.15);
    color: #ffffff;
    background: transparent !important;
    font-size: 14px;
  }
  .multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #212228;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid rgba(255,255,255,.15);
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 3 !important;
    -webkit-overflow-scrolling: touch;
  }
  .vdp-datepicker, .vdp-datepicker__calendar, .vdp-datepicker input {
    background-color: #202227 !important;
  }
</style>




// WEBPACK FOOTER //
// src/components/views/Company/MarketplaceTax.vue